import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { firebaseConfig as firebaseDevConfig } from "./firebaseConfig.dev";
import { firebaseConfig as firebaseProdConfig } from "./firebaseConfig.prod";

// Preferir variables de entorno. Si faltan en desarrollo, usar la configuración dev local.
const envConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
};

const envComplete = Object.values(envConfig).every((v) => typeof v === "string" && v.length > 0);
// PRIORIDAD: REACT_APP_ENV > NODE_ENV
// Por defecto: desarrollo (bimobi-dev)
const isProd = process.env.REACT_APP_ENV === "production" ||
  (process.env.NODE_ENV === "production" && process.env.REACT_APP_ENV !== "development");

// Selección de config:
// - Si todas las vars de entorno están presentes, usar envConfig.
// - Si es producción explícita, usar firebaseConfig.prod.ts (bimobi-prod)
// - Por defecto o desarrollo: usar firebaseConfig.dev.ts (bimobi-dev)
const firebaseConfig = envComplete
  ? envConfig
  : (isProd ? firebaseProdConfig : firebaseDevConfig);

// Log para debugging - ver qué BD se está usando
if (typeof window !== 'undefined') {
  console.log('🔥 Firebase Config:', {
    projectId: firebaseConfig.projectId,
    environment: isProd ? 'PRODUCCIÓN (Bimobi)' : 'DESARROLLO (Bimobi Dev)',
    source: envComplete ? 'Variables de entorno' : 'Archivo de configuración'
  });
}

const app = initializeApp(firebaseConfig);

// Configuración específica para desarrollo para evitar NGHTTP2_INTERNAL_ERROR
let db = getFirestore(app);

// Solo aplicar configuraciones especiales en desarrollo
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  try {
    console.log('🔧 [DEV] Configurando Firebase para evitar NGHTTP2_INTERNAL_ERROR...');
    // En desarrollo, usar configuraciones más robustas
    console.log('🔧 [DEV] Aplicando configuraciones de desarrollo para mejor estabilidad');
  } catch (e: any) {
    console.warn('[DEV] Configuración Firebase ya aplicada o no disponible:', e?.message || 'Error desconocido');
  }
}

export { db };
export const storage = getStorage(app);
export const auth = getAuth(app);
export { firebaseConfig };

